"use strict";

var LoggerInstance = require("js-logger").get("PaymentTermsApi");

var AbstractApi = require("./AbstractApi");

var ApiHelper = require("../shared/ApiHelper");

var PaymentTermsApi = class extends AbstractApi {
	getPaymentTermsHtml(themeId) {
		if (!themeId) {
			return ApiHelper.logErrorAndReturnRejectedDeferred(LoggerInstance, `ThemeId was not specified: ${themeId}.`);
		}

		return this.get({
			url: "/api/paymentterms",
			queryString: {
				themeId
			}
		});
	}

	getPaymentTermsControlRecord() {
		return this.get({
			url: "/api/x01/DDCPAYTERM"
		});
	}
};

module.exports = new PaymentTermsApi();
